import { Component, inject, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PriceControlComponent } from '@ep/shared';
import { MerchantSmsPriceControlComponent } from '@app/areas/merchants/controls/merchant-sms-price-control/merchant-sms-price-control.component';
import { MerchantOverviewFormService } from '@app/areas/merchants/services/merchant-overview-form.service';
import { Merchant, Representative } from '@shared/models';

@Component({
  selector: 'app-merchant-overview-form',
  templateUrl: './merchant-overview-form.component.html',
  styleUrls: ['./merchant-overview-form.component.scss'],
  standalone: true,
  imports: [
    InputTextModule,
    DropdownModule,
    ReactiveFormsModule,
    PriceControlComponent,
    MerchantSmsPriceControlComponent,
  ],
})
export class MerchantOverviewFormComponent {
  private readonly merchantOverviewFormService = inject(MerchantOverviewFormService);

  @Input() merchant: Merchant | null = null;
  @Input() representatives: Representative[] = [];

  protected merchantOverviewForm = this.merchantOverviewFormService.getForm();

  protected get representativeOptions(): { RepresentativeId: number; name: string }[] {
    return this.representatives.map((representative) => ({
      RepresentativeId: representative.RepresentativeId,
      name: `${representative.NameFirst} ${representative.NameLast}`,
    }));
  }
}
